module.exports = __webpack_public_path__ + "img/slider-people-3.5fd11024.png";